import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { IframeComponent } from './iframe/iframe.component';
import { TrackCasesComponent } from './track-cases/track-cases.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        ReactiveFormsModule
    ],
    declarations: [
        IframeComponent,
        TrackCasesComponent
    ]
})
export class SupportModule { }
